import React from "react";
import Dropzone from "react-dropzone";

import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

const UploadImgTypography = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  alignItems: "center",
  flexDirection: "row",
  cursor: "pointer",
  height: "100%",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    marginTop: theme.spacing(2),
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  borderWidth: 1,
  borderStyle: "dashed",
  borderColor: theme.palette.secondary.light,
  alignItems: "center",
  justifyContent: "center",
  padding: 2,
  display: "flex",
  width: "100px",
  height: "100px",
  borderRadius: "8px",
  position: "relative",
  [theme.breakpoints.down("sm")]: {
    marginRight: theme.spacing(1),
    height: "75px",
  },
}));

const CloseIcon = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: -1,
  right: -1,
  borderWidth: 1,
  borderStyle: "solid",
  width: "20px",
  height: "20px",
  backgroundColor: theme.palette.background.default,
  cursor: "pointer",
  borderRadius: "2px",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: "bold",
  [theme.breakpoints.down("sm")]: {
    width: "16px",
    height: "16px",
    fontSize: "10px",
  },
}));

const UploadMultipleImage = (props) => {
  const { multiImage, removeBusinessImage, type, setMultiImage } = props;
  return (
    <Grid
      item
      xs={12}
      sx={{ display: "flex", justifyContent: "space-between" }}
    >
      <ImageBox>
        {multiImage.length > 0 && (
          <CloseIcon
            onClick={() =>
              removeBusinessImage({ index: 0, imageUrl: multiImage[0] })
            }
          >
            X
          </CloseIcon>
        )}
        {multiImage.length > 0 && type === "edit" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={
              typeof multiImage[0] === "string"
                ? multiImage[0]
                : URL.createObjectURL(multiImage[0])
            }
          />
        ) : multiImage.length > 0 && type === "add" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={URL.createObjectURL(multiImage[0])}
          />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => {
              setMultiImage([
                ...multiImage,
                ...acceptedFiles.map((file) => Object.assign(file)),
              ]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input {...getInputProps()} />
                  <UploadImgTypography>Upload Image</UploadImgTypography>
                </div>
              </section>
            )}
          </Dropzone>
        )}
      </ImageBox>

      <ImageBox>
        {multiImage.length > 1 && (
          <CloseIcon
            onClick={() =>
              removeBusinessImage({ index: 1, imageUrl: multiImage[1] })
            }
          >
            X
          </CloseIcon>
        )}
        {multiImage.length > 1 && type === "edit" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={
              typeof multiImage[1] === "string"
                ? multiImage[1]
                : URL.createObjectURL(multiImage[1])
            }
          />
        ) : multiImage.length > 1 && type === "add" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={URL.createObjectURL(multiImage[1])}
          />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => {
              setMultiImage([
                ...multiImage,
                ...acceptedFiles.map((file) => Object.assign(file)),
              ]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input {...getInputProps()} />
                  <UploadImgTypography>Upload Image</UploadImgTypography>
                </div>
              </section>
            )}
          </Dropzone>
        )}
      </ImageBox>

      <ImageBox>
        {multiImage.length > 2 && (
          <CloseIcon
            onClick={() =>
              removeBusinessImage({ index: 2, imageUrl: multiImage[2] })
            }
          >
            X
          </CloseIcon>
        )}
        {multiImage.length > 2 && type === "edit" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={
              typeof multiImage[2] === "string"
                ? multiImage[2]
                : URL.createObjectURL(multiImage[2])
            }
          />
        ) : multiImage.length > 2 && type === "add" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={URL.createObjectURL(multiImage[2])}
          />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => {
              setMultiImage([
                ...multiImage,
                ...acceptedFiles.map((file) => Object.assign(file)),
              ]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input {...getInputProps()} />
                  <UploadImgTypography>Upload Image</UploadImgTypography>
                </div>
              </section>
            )}
          </Dropzone>
        )}
      </ImageBox>

      <ImageBox>
        {multiImage.length > 3 && (
          <CloseIcon
            onClick={() =>
              removeBusinessImage({ index: 3, imageUrl: multiImage[3] })
            }
          >
            X
          </CloseIcon>
        )}
        {multiImage.length > 3 && type === "edit" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={
              typeof multiImage[3] === "string"
                ? multiImage[3]
                : URL.createObjectURL(multiImage[3])
            }
          />
        ) : multiImage.length > 3 && type === "add" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={URL.createObjectURL(multiImage[3])}
          />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => {
              setMultiImage([
                ...multiImage,
                ...acceptedFiles.map((file) => Object.assign(file)),
              ]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input {...getInputProps()} />
                  <UploadImgTypography>Upload Image</UploadImgTypography>
                </div>
              </section>
            )}
          </Dropzone>
        )}
      </ImageBox>

      <ImageBox>
        {multiImage.length > 4 && (
          <CloseIcon
            onClick={() =>
              removeBusinessImage({ index: 4, imageUrl: multiImage[4] })
            }
          >
            X
          </CloseIcon>
        )}
        {multiImage.length > 4 && type === "edit" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={
              typeof multiImage[4] === "string"
                ? multiImage[4]
                : URL.createObjectURL(multiImage[4])
            }
          />
        ) : multiImage.length > 4 && type === "add" ? (
          <img
            width={"90%"}
            height={"80%"}
            alt={""}
            src={URL.createObjectURL(multiImage[4])}
          />
        ) : (
          <Dropzone
            onDrop={(acceptedFiles) => {
              setMultiImage([
                ...multiImage,
                ...acceptedFiles.map((file) => Object.assign(file)),
              ]);
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <section
                style={{
                  display: "flex",
                  height: "100%",
                }}
              >
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input {...getInputProps()} />
                  <UploadImgTypography>Upload Image</UploadImgTypography>
                </div>
              </section>
            )}
          </Dropzone>
        )}
      </ImageBox>
    </Grid>
  );
};

export default UploadMultipleImage;
